"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _celesteStoreProvider = require("../celeste-store-provider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// eslint-disable-next-line no-unused-vars

var ConnectedWrapper = function ConnectedWrapper(_ref) {
  var children = _ref.children,
    disconnectedComponent = _ref.disconnectedComponent;
  var wallet = (0, _celesteStoreProvider.useCelesteSelector)(function (state) {
    return state.walletReducer;
  });
  return wallet.isLoggedIn ? children : disconnectedComponent || null;
};
ConnectedWrapper.propTypes = {
  children: _propTypes["default"].node,
  disconnectedComponent: _propTypes["default"].element
};
var _default = ConnectedWrapper;
exports["default"] = _default;